// @flow

import * as React from 'react';

import { contactbook } from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectSetupOwner } from '../../../modules/selectors';
import { DomainContactForm } from '../DomainContactForm';
import {
  formSection2,
  useDomainContactFields,
  visitFormNodes,
} from '../helpers';
import type { FormValues } from '../types';

export type StateProps = {
  initialValues: FormValues,
};

export type OwnProps = {
  canWriteContactBook: boolean,
};

export type Props = {
  ...OwnProps,
  ...StateProps,
};

const Presenter = ({
  initialValues,
  canWriteContactBook,
}: Props): React.Node => {
  const { __ } = useTranslator();
  const orgId = useAppSelector(selectSetupOwner);

  // Good candidate to memoization.
  const fields = useDomainContactFields(false);

  const isWorking = useAppSelector(state =>
    contactbook.selectIsCreatingOne(state, orgId),
  );

  // Describes how the form will be displayed
  const formView = {
    name: 'form__root',
    type: 'form__root',
    children: [formSection2],
  };

  // In each form node, use the fields as default values.
  const decoratedFormView = visitFormNodes(formView, node => ({
    ...fields.find(field => field.name === node.name),
    ...node,
  }));

  return (
    <DomainContactForm
      mode="CreateContact"
      canWriteContactBook={canWriteContactBook}
      formView={decoratedFormView}
      cancelLabel={__('Cancel')}
      submitLabel={__('Create')}
      isWorking={isWorking}
      initialValues={initialValues}
    />
  );
};

export default Presenter;
